module.exports = __webpack_public_path__ + "img/12_maska_shit.62e07a4.svg";